import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_estore_expiry",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-550px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header flex-stack" }
const _hoisted_5 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = { class: "modal-body scroll-y pt-10 pb-15 px-lg-17" }
const _hoisted_8 = { class: "card-body py-3" }
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_11 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createVNode("th", { class: "ps-4 min-w-25px rounded-start" }, "#"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-25px" }, "Product")
  ])
], -1)
const _hoisted_12 = { class: "d-flex align-items-center" }
const _hoisted_13 = { class: "text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg" }
const _hoisted_14 = { class: "text-muted font-weight-bold d-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("h2", null, _toDisplayString(_ctx.pname) + " Expiry Date", 1),
          _createVNode("div", _hoisted_5, [
            _createVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Close.svg" })
            ])
          ])
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _createVNode("table", _hoisted_10, [
                _hoisted_11,
                _createVNode("tbody", null, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list2, (item, index) => {
                    return (_openBlock(), _createBlock("tr", { key: index }, [
                      _createVNode("td", null, "   " + _toDisplayString(index + 1), 1),
                      _createVNode("td", null, [
                        _createVNode("div", _hoisted_12, [
                          _createVNode("div", null, [
                            _createVNode("a", _hoisted_13, "(" + _toDisplayString(item.balance) + ") " + _toDisplayString(_ctx.pname), 1),
                            _createVNode("span", _hoisted_14, "Expires on " + _toDisplayString(item.expire_date.substring(0,10)), 1)
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}